// extracted by mini-css-extract-plugin
export default {"imageContent":"tn-z","modal":"un-z"};